export const ERROR_STATUS = [500, 404, 401];


// WEBPACK FOOTER //
// ./src/app/shared/types/constants.ts